Object.defineProperty(exports, "__esModule", { value: true });
exports.DuplexField = exports.FieldError = void 0;
const registry_1 = require("../field/registry");
const registry_2 = require("../inputField/registry");
var error_1 = require("./error");
Object.defineProperty(exports, "FieldError", { enumerable: true, get: function () { return error_1.FieldError; } });
function DuplexField(options) {
    return (targetInstance, fieldName) => {
        let isNullable = true;
        let inputNullable = true;
        if (options) {
            if (options.isNullable !== undefined) {
                isNullable = options.isNullable;
            }
            if (options.inputNullable !== undefined) {
                inputNullable = options.inputNullable;
            }
            delete options.isNullable;
            delete options.inputNullable;
        }
        const finalInputConfig = {
            property: fieldName,
            name: fieldName,
            isNullable: inputNullable,
            ...options
        };
        const finalConfig = {
            property: fieldName,
            name: fieldName,
            isNullable,
            ...options
        };
        registry_1.fieldsRegistry.set(targetInstance.constructor, fieldName, finalConfig);
        registry_2.inputFieldsRegistry.set(targetInstance.constructor, fieldName, finalInputConfig);
    };
}
exports.DuplexField = DuplexField;
//# sourceMappingURL=DuplexField.js.map